import "../style/ButtonGradient.css";

export const ButtonGradient = ({ children, className, disabled }) => {
  return (
    <button className={`border-gradient-hoop unselectable ${className}`}>
      <p>{children}</p>
    </button>
  );
};
